<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="pa-2" :elevation="10" tile>
            <v-card-text>
              <div
                class="text--primary text-center p-4 rounded-top"
                style="background-color: gainsboro"
              >
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(timKiem)">
                    <div class="container">
                      <div class="row">
                        <validation-provider
                          :name="$t('models.traCuu.thongTin')"
                          :rules="`required`"
                          v-slot="{ errors, valid }"
                          class="col-12"
                        >
                          <div class="row">
                            <label
                              for="txtSoCmnd"
                              class="col-md-3 col-12 d-flex align-items-center"
                            >
                              {{ $t("models.traCuu.nhapSoCmnd") }}
                            </label>
                            <div class="col-12 col-md-6">
                              <input
                                id="txtTraCuu"
                                type="text"
                                class="form-control"
                                v-model="soCmnd"
                                :placeholder="$t('models.traCuu.nhapSoCmnd')"
                                :class="{
                                  'is-invalid': errors[0],
                                  'is-valid': valid,
                                }"
                              /><span class="text-danger text-center col-12">{{
                                errors[0]
                              }}</span>
                            </div>
                            <div class="col-md-2 col-10">
                              <button
                                class="btn btn-info form-control"
                                id="btnTraCuu"
                              >
                                {{ $t("button.xacNhan") }}
                              </button>
                            </div>
                          </div>
                        </validation-provider>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- {{ thisinhs }} -->
    <v-container class="grey lighten-5">
      <v-card class="pa-2 pb-6" v-for="(hoSo, i) in thisinhs" :key="i">
        <div class="col-row">
          <div class="col-12 text-success">
            {{ $t("title.tenTruong") }} thông báo kết quả
            {{ hoSo.dotDangKy.tenDot }} như sau:
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ol>
              <li>
                <span> Họ và tên thí sinh:</span>
                <span class="font-weight-bold">{{ hoSo.thiSinh.hoTen }}</span>
              </li>
              <li>
                <span> Ngày tháng năm sinh:</span>
                <span class="font-weight-bold">{{
                  hoSo.thiSinh.ngaySinh | formatDate
                }}</span>
              </li>
              <li>
                <span> Số CMND/CCCD:</span>
                <span class="font-weight-bold">{{ hoSo.thiSinh.soCmnd }}</span>
              </li>
              <li>
                <span> Đối tượng:</span>
                <span class="font-weight-bold">{{
                  hoSo.thiSinh.maDoiTuong
                }}</span>
              </li>
              <li>
                <span> Khu vực:</span>
                <span class="font-weight-bold">{{
                  hoSo.thiSinh.maKhuVuc
                }}</span>
              </li>
            </ol>
          </div>
          <div class="col-12">Thông tin xét tuyển</div>
        </div>
        <v-card class="pa-2">
          <v-data-table
            :headers="headers"
            :items="hoSo.ketQuaXetTuyens"
            :disable-pagination="true"
            :hide-default-footer="true"
            :disable-sort="true"
          >
            <template v-slot:body="{ items }">
              <tbody name="list" is="transition-group" v-if="items.length > 0">
                <tr v-for="(item, index) in items" :key="index" class="p-4">
                  <td class="pt-3 pb-3">
                    <span class="font-weight-bold text-uppercase">
                      {{ index + 1 }}
                    </span>
                  </td>
                  <td class="pt-3 pb-3">
                    <span class="text-data">
                      {{ item.maHoSo }}
                    </span>
                  </td>
                  <td class="pt-3 pb-3">
                    <span class="text-data">
                      {{ item.maNganh }}
                    </span>
                  </td>
                  <td class="pt-3 pb-3">
                    <span class="text-data">
                      {{ item.tenNganh }}
                    </span>
                  </td>
                  <td class="pt-3 pb-3">
                    <span class="font-weight-bold text-uppercase">
                      {{ item.maToHop }} ({{ item.tenToHop }})
                    </span>
                  </td>
                  <td class="pt-3 pb-3">
                    <span class="font-weight-bold text-uppercase">
                      {{ item.tongDiem }}
                    </span>
                  </td>
                  <td class="pt-3 pb-3">
                    <span class="font-weight-bold text-uppercase">
                      {{ item.diemXetTuyen }}
                    </span>
                  </td>

                  <td class="pt-3 pb-3">
                    <span
                      class="font-weight-bold text-uppercase"
                      :class="colorText(item.ketQua)"
                    >
                      {{ item.ketQua }}
                    </span>
                  </td>
                  <td
                    class="pt-3 pb-3"
                    v-if="showButton(hoSo.dotDangKy) && item.ketQua == 'Đỗ'"
                  >
                    <button
                      class="btn btn-info"
                      @click="nhapHoc(hoSo.trungTuyen, hoSo.dotDangKy)"
                    >
                      {{ $t("button.nhapHoc") }}
                    </button>
                  </td>
                  <td class="pt-3 pb-3" v-else></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4">
                    <div class="text-danger text-uppercase h3 text-center p-5">
                      {{ message }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
        <div class="row">
          <div class="col-12">
            <ol>
              <li>Nhà trường mời em thực hiện xác nhận nhập học và nhập học theo phương thức trực tuyến (online) theo địa chỉ <a href="http://nhaphoc.tlu.edu.vn" target="_blank" > http://nhaphoc.tlu.edu.vn</a> </li>
              <li>
                Thời gian xác nhận nhập học và nhập học: từ 14h00 ngày 08/10/{{ new Date().getFullYear() }} đến 17h00 ngày 09/10/{{ new Date().getFullYear() }} (tân sinh viên làm thủ tục xác nhận và nhập học đồng thời trên trang <a href="http://nhaphoc.tlu.edu.vn" target="_blank" >  nhaphoc.tlu.edu.vn</a>)
              </li>
              <li>
                Sau khi hoàn thành quá trình nhập học trực tuyến, sinh viên gửi hồ sơ xác nhận và nhập học qua hình thức chuyển phát nhanh về Trường gồm:
                <ul>
                  <li>
                    Giấy chứng nhận kết quả thi tốt nghiệp THPT năm {{ new Date().getFullYear() }} (bản gốc)
                  </li>
                  <li>
                    Giấy chứng nhận tốt nghiệp tạm thời năm {{ new Date().getFullYear() }} (bản gốc) hoặc bản sao bằng tốt nghiệp đối với thí sinh tốt nghiệp trước tháng 8/{{ new Date().getFullYear() }}.
                  </li>
                  <li>
                    Bản sao công chứng học bạ.
                  </li>
                </ul>
              </li>
            </ol>
            <p>
             - Thời gian gửi hồ sơ: từ <span class="font-weight-bold"> 08/10/{{ new Date().getFullYear() }}</span> đến hết ngày <span class="font-weight-bold"> 15/10/{{ new Date().getFullYear() }}.</span>
            </p>
            <p >
              <span class="font-weight-bold"> Địa chỉ nhận thư: Phòng Đào tạo, Trường Đại học Thủy lợi - Số 175 Tây Sơn, Đống Đa, Hà Nội, điện thoại 0243.5631537
                </span>
            </p>
          </div>
        </div>
      </v-card>
      <v-card class="pa-2" v-if="thisinhs.length == 0">
        <div class="text-danger text-uppercase h3 text-center p-5">
          {{ message }}
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TraCuu from "./tracuu";
export default TraCuu;
</script>

<style lang="scss" scoped>
div.v-application {
  display: block;
  th {
    white-space: nowrap;
  }
  div.v-content__wrap {
    width: 100%;
  }
}
tr {
  td {
    text-transform: uppercase;
    .text-data {
      font-size: 16px;
    }
  }
}
.indent {
  padding-left: 0.6em;
}
</style>
